export default function LogoIcon({ className = '' }: { className?: string }) {
  return (
    <img
      src="https://luckyholidays.in/logo.svg"
      alt="Lucky Holidays logo"
      aria-label="Lucky Holidays"
      role="img"
      className={`${className} block max-w-full max-h-full object-contain object-center select-none`}
      loading="lazy"
      decoding="async"
      draggable={false}
    />
  );
}